import { Badge } from '@/components/ui';
import {
  formatSentToClientDate,
  SENT_TO_CLIENT_LABEL,
  sentToClientTitle,
} from '@/lib/sent-to-client';

/**
 * Marks an invoice Xero has flagged as sent to the client. Owner decision
 * 2026-10-09. Wording lives in `lib/sent-to-client.ts`; read its header.
 *
 * Renders NOTHING when the invoice is not known to be sent, and nothing when
 * the field is absent (an older API) — an unanswered question must not render
 * as either answer.
 *
 * The label is real text, so the fact never rests on colour. `neutral` because
 * a sent invoice is an ordinary state, not a status to act on. ⛔ Never worded
 * as delivered or read.
 */
export function SentToClientBadge({
  sent,
  sentAt,
}: {
  sent: boolean | undefined;
  sentAt: string | null | undefined;
}) {
  const title = sentToClientTitle(sent, sentAt);
  if (title === null) return null;

  const label =
    sentAt === null || sentAt === undefined
      ? SENT_TO_CLIENT_LABEL
      : `${SENT_TO_CLIENT_LABEL} · ${formatSentToClientDate(sentAt)}`;

  return (
    <Badge tone="neutral" variant="outline" title={title}>
      {label}
    </Badge>
  );
}
